module.exports = __webpack_public_path__ + "images/help/video-calendar-small@2x-30010366a49651dd901eb1205252fa4e.png";